import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faBars, faChevronDown, faChevronRight, faChevronUp, faClose, faPlay } from '@fortawesome/free-solid-svg-icons';
import { map } from 'rxjs';
import { Footer } from './components/footer/footer';
import { NavbarMobile } from './components/navbar-mobile/navbar-mobile';
import { Navbar } from './components/navbar/navbar';
import { TopHeader } from './components/top-header/top-header';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navbar, Footer, AsyncPipe, NavbarMobile, TopHeader],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  constructor(lib: FaIconLibrary) {
    lib.addIcons(
      faChevronRight,
      faBars, 
      faClose,
      faPlay,
      faChevronDown, 
      faChevronUp,
      faChevronRight
    )
  }
  private breakpointObserver = inject(BreakpointObserver);

  isMobile$ = this.breakpointObserver
    .observe([Breakpoints.Handset])
    .pipe(map(result => result.matches));
}
